module.exports = __webpack_public_path__ + "img/heir.148a9271.svg";